import React from "react";
import { post } from "../../../adapters/xhr/api";
import styleRegister from "./Register.module.css";
import logo from "../../../assets/img/logo.png";
/* import idNumber from "../../../assets/img/id_number.png"; */
import { Link } from "react-router-dom";
import InputElement from "../../form/InputElement";
import { Fragment, useEffect, useState, useRef } from "react";
import {
  ValidateRegister,
  validateRegisterFields,
} from "../../../validations/ValidateRegister";
import { validateEgyptianPhoneNumberWithPhoneInput } from "../../../helpers/Validation";

import {
  getBirthsPlaces,
  /* getDistricts, */
  getGenders,
  /* getGovernorates, */
  getNationalities,
  /* getStreetVillage,
  getStreets,
  getVillages, */
} from "../../../adapters/apis/lookups/lookups";
import {
  /* register , */ registerSendOTP,
} from "../../../adapters/apis/auth/auth";
import SearchSelectElement from "../../form/SearchSelectElement";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import moment from "moment";
import DatePickerFormated from "../../form/DatePickerFormated";
import Footer from "../../../layouts/footer/Footer";
import { useNavigate } from "react-router-dom";
import AttachmentName from "../../../helpers/AttachmentName";
import TermsAndCondition from "../../../pages/support/TermsAndCondition";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isValidPhoneNumber } from "libphonenumber-js";
import Modal from "react-modal";
import stylesModal from "../../../components/UnifiedTaxDeclaration/forms/formTypes/Modal.module.css";

function Register() {
  Modal.setAppElement("body");

  const navigate = useNavigate();

  const user_data = {
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    password: "",
    password_confirmation: "",
    national_id: "",
    national_id_file: "",
    passport_num: "",
    passport_num_file: "",
    /* factory_num: "", */
    birth_date: "",
    birth_date_dateformat: "",
    birth_place: "",
    gender: "",
    /* governorate_id: "",
    district_id: "",
    village_id: "",
    street_id: "",
    real_estate_num: "",
    street_other: "", */
  };

  const [new_user, setNewUser] = useState({
    ...user_data,
    nationality_code: "EG",
    country_code: "eg",
    other_birth_place: "",
  });
  const [error_new_user, setNewUserError] = useState({
    ...user_data,
    nationality_code: "",
  });
  const [nationalities, setNationalities] = useState([]);
  /* const [govs, setGovs] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [villages, setVillages] = useState([]);
  const [streets, setStreets] = useState([]); */
  const [birthPlaces, setBirthPlaces] = useState([]);
  const [genders, setGenders] = useState([]);
  const [submissionError, setSubmissionError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const nationalIdFileInputRef = useRef({});
  const passportFileInputRef = useRef({});
  const [inputKeys, setInputKeys] = useState({});
  const [isRegistering, setIsRegistering] = useState(false);
  const [uploadingCount, setUploadingCount] = useState(0);
  const isSubmitDisabled = isRegistering || uploadingCount > 0;
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptTermsError, setAcceptTermsError] = useState("");
  const [currentView, setCurrentView] = useState("register");
  const [phoneError, setPhoneError] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    getNationalities()
      .then((res) => {
        setNationalities(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    /* getGovernorates()
      .then((res) => {
        setGovs(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      }); */
    getBirthsPlaces()
      .then((res) => {
        setBirthPlaces(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    getGenders()
      .then((res) => {
        setGenders(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const nationalites_options = nationalities.map((element) => {
    return { value: element.code, label: element.name };
  });

  const birth_place_options = birthPlaces.map((element) => {
    return { value: element.code, label: element.name };
  });
  const genders_options = genders.map((element) => {
    return { value: element.id, label: element.name };
  });

  function handleChange(parentCompenent, compenent, key, value) {
    validateRegisterFields(setError, new_user, key, value);
    setNewUser((prev) => ({
      ...prev,
      [key]: value,
    }));
    if (value instanceof File) {
      if (key === "national_id_file" || key === "passport_num_file") {
        uploadDocument(value, key);
      }
    }
    if (key === "nationality_code") {
      setPhoneError(null);
      setNewUser((prev) => ({
        ...prev,
        country_code: "eg",
        dial_code: "20",
        mobile: "20",
      }));
    }
  }
  const uploadDocument = async (file, fieldName) => {
    setUploadingCount((c) => c + 1);
    try {
      const data = new FormData();
      data.append("file", file);
      const response = await post(
        "api/register/upload-attachments",
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        },
        data,
      );

      setNewUser((prev) => ({
        ...prev,
        [`${fieldName}_path`]: response?.data?.data?.path,
        [`${fieldName}_url`]: response?.data?.data?.full_url,
        [`${fieldName}_name`]: response?.data?.data?.original_file_name,
      }));

      setError(fieldName, "");
    } catch (error) {
      setNewUser((prev) => ({ ...prev, [fieldName]: null }));

      if (error.status === 422) {
        setError(fieldName, error?.response?.data?.errors?.file[0]);
      } else {
        setError(fieldName, "حدث خطأ أثناء رفع الملف");
      }
    } finally {
      setUploadingCount((c) => Math.max(c - 1, 0)); // ✅ ده اللي كان ناقص
    }
  };
  const handleRemoveDocument = (fieldName) => {
    // 1. Reset the new_user state keys for the specific document
    setNewUser((prev) => ({
      ...prev,
      [fieldName]: null,
      [`${fieldName}_path`]: null,
      [`${fieldName}_url`]: null,
      [`${fieldName}_name`]: null,
    }));

    // 2. Clear the physical input via its specific Ref
    const targetRef =
      fieldName === "national_id_file"
        ? nationalIdFileInputRef
        : passportFileInputRef;

    if (targetRef?.current) {
      targetRef.current.value = "";
    }

    // 3. Force re-render of the specific InputElement using key logic
    setInputKeys((prev) => ({
      ...prev,
      [fieldName]: (prev[fieldName] || 0) + 0.1,
    }));

    // 4. Trigger the validation error message immediately
    setError(fieldName, "يجب رفع الصورة");
  };

  useEffect(() => {
    if (!nationalIdFileInputRef.current) {
      nationalIdFileInputRef.current = React.createRef();
    }

    if (!passportFileInputRef.current) {
      passportFileInputRef.current = React.createRef();
    }
  }, []);
  function handleChangeDatePicker(parentCompenent, compenent, key, value) {
    validateRegisterFields(setError, new_user, key, value);
    setNewUser((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  /*  function handleChangeStreet(parentCompenent, compenent, key, value) {
    //load villages by village_id

    // reset next levels

    if (parseInt(value) !== -1) {
      if (value !== "") {
        getStreetVillage(value)
          .then((res) => {
            // handleChangeVillage(
            //   parentCompenent,
            //   compenent,
            //   "village_id",
            //   res.data.data.id,
            //   true,
            //   false
            // );
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        setVillages([]);
      }
    }
    setNewUser((prev) => ({
      ...prev,
      street_other: "",
    }));
    handleChange(parentCompenent, compenent, key, value);
  } */

  function setError(key, value) {
    setNewUserError((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  const validatePhoneBeforeSubmit = () => {
    const value = new_user?.mobile;
    const dialCode = new_user?.dial_code;
    const countryCode = new_user?.country_code;
    const nationalNumber = value?.replace(dialCode, "")?.replace(/\D/g, "");
    if (
      value === dialCode ||
      value === "" ||
      value === null ||
      value === undefined
    ) {
      setPhoneError("يجب ادخال رقم الهاتف المحمول");
      return false;
    }

    if (
      new_user?.nationality_code === "EG" &&
      !validateEgyptianPhoneNumberWithPhoneInput(value)
    ) {
      setPhoneError(
        "رقم الهاتف المدخل يجب أن يكون رقم هاتف محمول مصريًا صالحًا. يُرجى اختيار مفتاح الدولة (+20) وإدخال رقم هاتف مصري صحيح",
      );
      return false;
    }

    // Egypt-specific rules
    if (countryCode === "eg") {
      const regex = /^(?:0?)(10|11|12|15)\d{8}$/;
      if (!regex.test(nationalNumber)) {
        setPhoneError(
          "رقم الهاتف المدخل يجب أن يكون رقم هاتف محمول مصريًا صالحًا. يُرجى اختيار مفتاح الدولة (+20) وإدخال رقم هاتف مصري صحيح",
        );
        return false;
      }
    }

    // General validation for other countries
    if (!isValidPhoneNumber("+" + value)) {
      setPhoneError(
        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
      );
      return false;
    }

    // Length rule (≤15 digits excluding country code)
    if (nationalNumber?.length < 6 || nationalNumber?.length > 15) {
      setPhoneError(
        "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
      );
      return false;
    }

    setPhoneError(null);
    return true;
  };

  const handleValidateOpenModal = () => {
    const isRegisterValid = ValidateRegister(setError, new_user);
    const isPhoneValid = validatePhoneBeforeSubmit();

    if (isRegisterValid && isPhoneValid) {
      setShowModal(true);
    } else {
      return; // stop if either fails
    }
  };

  // reset next levels when you change the governorate
  /* const resetDistrict = () => {
    // reset districts, villages and streets
    setNewUser((prev) => ({
      ...prev,
      district_id: "",
      village_id: "",
      street_id: "",
    }));
    setDistricts([]);
    setVillages([]);
    setStreets([]);
  }; */

  // reset next levels when you change the district
  /*  const resetVillage = () => {
    // reset villages and streets
    setNewUser((prev) => ({
      ...prev,
      village_id: "",
      street_id: "",
    }));
    setVillages([]);
    setStreets([]);
  }; */

  // reset next levels when you change the village
  /* const resetStreet = () => {
    // reset street
    setNewUser((prev) => ({
      ...prev,
      street_id: "",
    }));
    setStreets([]);
  }; */

  function registerUser() {
    setShowModal(false);
    if (isRegistering || uploadingCount > 0) return;
    setSubmissionError(null);

    if (!acceptTerms) {
      setAcceptTermsError(
        "يجب الإقرار على الشروط والأحكام وسياسة الخصوصية والموافقة عليهما",
      );
      return;
    } else {
      setAcceptTermsError("");
    }

    if (!ValidateRegister(setError, new_user)) {
      return;
    }

    setIsRegistering(true);
    setIsLoading(true);

    const isPhoneValid = validatePhoneBeforeSubmit();

    if (
      ValidateRegister(setError, new_user) &&
      phoneError == null &&
      isPhoneValid
    ) {
      const data = new FormData();
      data.append("first_name", new_user.first_name);
      data.append("last_name", new_user.last_name);
      data.append("email", new_user.email);
      data.append("mobile", new_user.mobile);
      data.append("country_code", new_user.country_code);
      data.append("dial_code", new_user.dial_code);
      data.append("password", new_user.password);
      data.append("password_confirmation", new_user.password_confirmation);
      if (new_user.nationality_code === "EG") {
        data.append("national_id", new_user.national_id);
        if (new_user.national_id_file) {
          data.append("national_id_file", new_user.national_id_file);
        }
      } else {
        data.append("passport_num", new_user.passport_num);
        if (new_user.passport_num_file) {
          data.append("passport_num_file", new_user.passport_num_file);
        }
      }
      /* data.append("governorate_id", new_user.governorate_id);
          data.append("district_id", new_user.district_id);
          data.append("village_id", new_user.village_id);
          data.append(
            "street_id",
            parseInt(new_user.street_id) === -1 ? 0 : new_user.street_id
          );
          data.append("real_estate_num", new_user.real_estate_num);
          data.append("street_other", new_user.street_other); 
      */
      data.append("nationality_code", new_user.nationality_code);
      // new data
      data.append("gender", new_user.gender);
      if (new_user.birth_place == 88) {
        data.append("other_birth_place", new_user.other_birth_place);
      }
      data.append("birth_place", new_user.birth_place);
      data.append("birth_date", new_user.birth_date);

      //register(data)   // OLD REGISTRATION API
      registerSendOTP(data)
        .then((res) => {
          const result = res?.data;
          if (result.code === 0) {
            const request_code = result?.data?.request_code;
            sessionStorage.setItem("context", result?.data?.context);
            sessionStorage.setItem("mobile", result?.data?.mobile);
            sessionStorage.setItem("request_code", request_code);
            sessionStorage.setItem("user_id", result?.data?.user_id);
            sessionStorage.setItem(
              "sms_otp_expire",
              result?.data?.sms_otp_expire,
            );
            sessionStorage.setItem("pass", new_user?.password);
            sessionStorage.setItem("email", new_user?.email);
            if (result?.data?.country_code === "eg") {
              navigate(
                `/confirm-otp?token=${encodeURIComponent(request_code)}`,
                {
                  state: { request_code },
                },
              );
            } else {
              navigate(`/mail-verify?email=${new_user?.email}`);
            }
          }
          /*  
          window.scrollTo(0, 0);
          setNewUser({ ...user_data, nationality_code: "EG" });
          setNewUserError({ ...user_data, nationality_code: "" });
          navigate("/login", { state: { success: true } }); */
        })
        .catch((err) => {
          setIsLoading(false);

          if (err.response.status === 400 || err.response.status === 422) {
            // If there are validation errors (like 422)
            if (err.response.data.errors) {
              Object.keys(err.response.data.errors).forEach((key) => {
                setError(key, err.response.data.errors[key][0]);
              });
            }
            // Otherwise show the single message (most 400 cases)
            else {
              const errorMsg = err.response.data.message;
              setSubmissionError(errorMsg);
            }
          } else {
            const errorMsg = err.response.data.message;
            setSubmissionError(errorMsg);
          }
          /* setIsLoading(false);
          if (!err?.response) {
            console.log("No Server Response");
          } else if (err.response?.status === 500) {
            console.log("server error: ", err.response.data.message);
          } else if (err.response?.status === 422) {
            if (err?.response?.data?.errors) {
              Object.keys(err.response.data.errors).forEach((key) => {
                setError(key, err.response.data.errors[key][0]);
              });
            }
          } else {
            console.log("unknown error: ", err.response);
          } */
        })
        .finally(() => {
          setIsRegistering(false);
          setIsLoading(false);
        });
    } else {
      setIsRegistering(false);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    sessionStorage.setItem("register_form", JSON.stringify(new_user));
  }, [new_user]);

  return (
    <>
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}
        overlayClassName={stylesModal.overlay}
        className={stylesModal.content}
      >
        <div className="col-lg-8 text-center">
          <h5>
            {new_user.country_code === "eg"
              ? "سوف يتم إرسال رمز التحقق OTP على رقم الهاتف (رقم الهاتف الذي تم استخدامه أثناء عملية إنشاء حساب) هل تريد المتابعة؟"
              : "سوف يتم إرسال بريد التفعيل إلى البريد الإلكتروني (البريد الإلكتروني الذي تم استخدامه أثناء عملية إنشاء حساب) هل تريد المتابعة؟"}
          </h5>
          <div className="d-flex gap-4 justify-content-center">
            <button className="btn btn-primary px-3" onClick={registerUser}>
              {new_user.country_code === "eg"
                ? "نعم، إرسال رمز التحقق"
                : "نعم، إرسال بريد التفعيل"}
            </button>
            <button
              className="btn btn-danger px-3"
              onClick={() => setShowModal(false)}
            >
              {new_user.country_code === "eg"
                ? "لا، تعديل رقم الهاتف"
                : "لا، تعديل البريد الإلكتروني"}
            </button>
          </div>
        </div>
      </Modal>
      {currentView === "register" ? (
        <>
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <section className={styleRegister["register-section"]}>
              <div className="container">
                <div className="justify-content-center">
                  <div className="text-center mt-4 mb-5">
                    <Link to="/">
                      <img src={logo} alt="..." />
                    </Link>
                  </div>
                  {submissionError && (
                    <div
                      className="alert alert-danger  mt-3"
                      id="backend_error"
                      role="alert"
                    >
                      <li className="">{submissionError}</li>

                      {}
                    </div>
                  )}
                  <div className={`card ${styleRegister["card"]}`}>
                    <div className={`card-body ${styleRegister["card-body"]}`}>
                      <h5
                        className={`${styleRegister["card-title"]} card-title mb-5 fw-bold`}
                      >
                        إنشاء حساب جديد للممول
                      </h5>

                      <div className="row">
                        <div className="col-lg-4 col-sm-6">
                          <InputElement
                            mb4="mb-4"
                            name="first_name"
                            labelHtmlFor="first_name"
                            labelClassName={` required ${styleRegister["form-label"]} form-label`}
                            labelText="الإسم الأول"
                            inputType="text"
                            inputClassName={`${styleRegister["form-control"]} form-control`}
                            inputID="first_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.first_name}
                            value={new_user.first_name}
                            onChange={handleChange}
                            maxLength={24}
                            allowedPattern={
                              /^(?!.*\p{P})(?:[A-Za-z]+(?:\s[A-Za-z]*)?|[\u0600-\u06FF]+(?:\s[\u0600-\u06FF]*)?|)$/u
                            }
                          />
                        </div>
                        <div className="col-lg-4 col-sm-6">
                          <InputElement
                            mb4="mb-4"
                            name="last_name"
                            labelHtmlFor="last_name"
                            labelClassName={` required ${styleRegister["form-label"]} form-label`}
                            labelText="باقي الإسم"
                            inputType="text"
                            inputClassName={`${styleRegister["form-control"]} form-control`}
                            inputID="last_name"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.last_name}
                            value={new_user.last_name}
                            onChange={handleChange}
                            maxLength={64}
                            allowedPattern={
                              /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                            }
                          />
                        </div>
                        <div className="col-lg-4 col-sm-6">
                          <SearchSelectElement
                            mb4="mb-4"
                            labelHtmlFor="nationality_code"
                            labelClassName={` required form-label ${styleRegister["form-label"]}`}
                            labelText="الجنسية"
                            selectClassName={`${styleRegister["form-select"]} form-select`}
                            selectID="nationality_code"
                            inputId="nationality_code_input"
                            name="nationality_code"
                            options={nationalites_options}
                            default="أختار الجنسية.."
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.nationality_code}
                            value={new_user.nationality_code}
                            onChange={handleChange}
                            parentCompenent="x"
                            type="string"
                          />
                        </div>
                        {new_user.nationality_code === "EG" ? (
                          <Fragment>
                            <div className="col-lg-4 col-sm-6">
                              <InputElement
                                name="national_id"
                                mb4="mb-4"
                                labelHtmlFor="national_id"
                                labelClassName={` required ${styleRegister["form-label"]} form-label`}
                                labelText="الرقم القومي"
                                inputType="text"
                                inputClassName={`${styleRegister["form-control"]} form-control`}
                                inputID="national_id"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                pText={error_new_user.national_id}
                                value={new_user.national_id}
                                onChange={handleChange}
                                maxLength={14}
                                max={999999999999}
                                allowedPattern={/^[1-9]\d*$/}
                              />
                            </div>
                            <div className="col-lg-4 col-sm-6 mb-5">
                              <InputElement
                                key={inputKeys.national_id_file || 0}
                                fileInputRef={nationalIdFileInputRef}
                                mb4="mb-4"
                                inputIcon={`${styleRegister["input-icon"]} ${styleRegister["input-icon-custom"]}  input-icon`}
                                labelHtmlFor="national_id_file"
                                labelClassName={`required ${styleRegister["form-label"]} form-label`}
                                labelText="مرفق الرقم القومي"
                                inputType="file"
                                tooltipText=" الحد الاقصي للملف 5 ميجا وصيغة الملف يجب ان تكون  PDF, JFIF, JPEG, JPG, PNG"
                                inputClassName={` ${styleRegister["form-control"]} form-control ${styleRegister["fileCustom"]}`}
                                inputID="national_id_file"
                                name="national_id_file"
                                fileName="إرفاق ملف"
                                pClassName={`${styleRegister["text-danger-register"]} text-danger mb-0 me-2 fw-bolder`}
                                icon="fa-solid fa-cloud-arrow-up"
                                pText={error_new_user.national_id_file}
                                onChange={handleChange}
                              />
                            </div>
                            {new_user?.national_id_file_url && (
                              <div className="col-lg-4 col-sm-6">
                                <label
                                  className={`${styleRegister["form-label"]} form-label`}
                                ></label>
                                <div className="d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-1 px-2 align-items-center mb-3">
                                  <p
                                    className="mb-0 file-name fs-6"
                                    title={AttachmentName(
                                      new_user.national_id_file_url,
                                    )}
                                  >
                                    {AttachmentName(
                                      new_user.national_id_file_url,
                                    )}
                                  </p>

                                  <div className="d-flex align-items-center py-2">
                                    <span
                                      type="button"
                                      onClick={() =>
                                        handleRemoveDocument("national_id_file")
                                      }
                                      className="text-danger border-0"
                                    >
                                      <i className="fa-solid fa-trash fa-lg px-2"></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Fragment>
                        ) : new_user.nationality_code !== "" ? (
                          <Fragment>
                            <div className="col-lg-4 col-sm-6">
                              <InputElement
                                name="passport_num"
                                mb4="mb-4"
                                labelHtmlFor="passport_num"
                                labelClassName={` required ${styleRegister["form-label"]} form-label`}
                                labelText="رقم جواز السفر "
                                inputType="text"
                                inputClassName={`${styleRegister["form-control"]} form-control`}
                                inputID="passport_num"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                pText={error_new_user.passport_num}
                                value={new_user.passport_num}
                                onChange={handleChange}
                                maxLength={24}
                                allowedPattern={/^[A-Za-z0-9/-]+$/}
                              />
                            </div>
                            <div className="col-lg-4 col-sm-6 mb-5">
                              <InputElement
                                key={inputKeys.passport_num_file || 0}
                                fileInputRef={passportFileInputRef}
                                mb4="mb-4"
                                inputIcon={`${styleRegister["input-icon"]} ${styleRegister["input-icon-custom"]}  input-icon`}
                                labelHtmlFor="passport_num_file"
                                labelClassName={` required ${styleRegister["form-label"]} form-label`}
                                labelText="مرفق جواز السفر "
                                inputType="file"
                                tooltipText=" الحد الاقصي للملف 5 ميجا وصيغة الملف يجب ان تكون  PDF, JFIF, JPEG, JPG, PNG"
                                inputClassName={`${styleRegister["form-control"]} form-control ${styleRegister["fileCustom"]}`}
                                inputID="passport_num_file"
                                name="passport_num_file"
                                fileName="إرفاق ملف"
                                pClassName={`${styleRegister["text-danger-register"]} text-danger mb-0 me-2 fw-bolder`}
                                icon="fa-solid fa-cloud-arrow-up"
                                pText={error_new_user.passport_num_file}
                                onChange={handleChange}
                              />
                            </div>
                            {new_user?.passport_num_file_url && (
                              <div className="col-lg-4 col-sm-6">
                                <label
                                  className={`${styleRegister["form-label"]} form-label`}
                                ></label>
                                <div className="d-flex border border-2 rounded-3 shadow-sm fs-6 justify-content-between bg-light py-1 px-2 align-items-center mb-3">
                                  <p
                                    className="mb-0 file-name fs-6"
                                    title={AttachmentName(
                                      new_user.passport_num_file_url,
                                    )}
                                  >
                                    {AttachmentName(
                                      new_user.passport_num_file_url,
                                    )}
                                  </p>
                                  <div className="d-flex align-items-center py-2">
                                    <span
                                      type="button"
                                      onClick={() =>
                                        handleRemoveDocument(
                                          "passport_num_file",
                                        )
                                      }
                                      className="text-danger border-0"
                                    >
                                      <i className="fa-solid fa-trash fa-lg px-2"></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            )}
                          </Fragment>
                        ) : null}
                        <div className="col-lg-4 col-sm-6">
                          <div className="mb-4">
                            <label
                              htmlFor="mobile"
                              className={`required ${styleRegister["form-label"]} form-label`}
                            >
                              رقم الهاتف المحمول
                            </label>

                            <PhoneInput
                              country={new_user?.country_code || "eg"} // default Egypt
                              preferredCountries={[
                                "eg",
                                "sa",
                                "ae",
                                "jo",
                                "kw",
                                "qa",
                                "bh",
                                "om",
                                "ma",
                              ]}
                              value={new_user.mobile}
                              onChange={(value, country) => {
                                // When the country changes, reset to just the dial code
                                if (
                                  country?.countryCode !==
                                  new_user?.country_code
                                ) {
                                  value = country.dialCode;
                                }
                                const nationalNumber = value
                                  ?.replace(country?.dialCode, "")
                                  ?.replace(/\D/g, "");

                                // ✅ Egypt-specific normalization: remove extra leading 0
                                if (
                                  country?.countryCode === "eg" &&
                                  nationalNumber?.startsWith("0")
                                ) {
                                  value =
                                    country?.dialCode +
                                    nationalNumber?.slice(1);
                                }

                                // ✅ Length validation, but don’t wipe the value
                                if (
                                  (nationalNumber?.length < 6 ||
                                    nationalNumber?.length > 15) &&
                                  value !== country?.dialCode
                                ) {
                                  setPhoneError(
                                    "يجب ادخال الصيغة الصحيحة لرقم الهاتف المحمول وفقا للدولة المختارة",
                                  );
                                  // keep the current value instead of returning
                                  handleChange("", "", "mobile", value);
                                } else {
                                  setPhoneError(null);
                                  handleChange("", "", "mobile", value);
                                }

                                handleChange("", "", "mobile", value);

                                handleChange(
                                  "",
                                  "",
                                  "country_code",
                                  country?.countryCode,
                                );
                                handleChange(
                                  "",
                                  "",
                                  "dial_code",
                                  country?.dialCode,
                                );
                              }}
                              inputProps={{
                                name: "mobile",
                                id: "mobile",
                                required: true,
                                className: `phone-control form-control`,
                              }}
                              inputProps={{
                                name: "mobile",
                                id: "mobile",
                                required: true,
                                className: `phone-control form-control`,
                                placeholder: "",
                              }}
                              containerClass="w-100"
                              inputClass="w-100"
                              dropdownClass="custom-dropdown"
                              enableAreaCodes={false}
                              countryCodeEditable={false}
                              enableSearch={true}
                            />

                            {(phoneError || error_new_user.mobile) && (
                              <p className="text-danger mb-0 mt-2 me-2 fw-bolder">
                                {phoneError || error_new_user.mobile}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                          <DatePickerFormated
                            name="birth_date"
                            name_datepicker="birth_date_dateformat"
                            mb4="mb-4"
                            labelHtmlFor="birth_date"
                            labelClassName={` required ${styleRegister["form-label"]} form-label`}
                            labelText="تاريخ الميلاد"
                            inputType="datePicker"
                            maxDate={moment()}
                            inputClassName={`${styleRegister["form-control"]} form-control`}
                            inputID="birth_date"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.birth_date}
                            value={new_user.birth_date_dateformat}
                            valueDate={new_user.birth_date}
                            onChange={handleChangeDatePicker}
                          />
                        </div>

                        <div className="col-lg-4 col-sm-6">
                          <SearchSelectElement
                            mb4="mb-4"
                            labelHtmlFor="birth_place"
                            labelClassName={` required form-label ${styleRegister["form-label"]}`}
                            labelText="محل الميلاد"
                            selectClassName={`${styleRegister["form-select"]} form-select`}
                            selectID="birth_place"
                            inputId="birth_place_name"
                            name="birth_place"
                            options={birth_place_options}
                            default="أختار محل الميلاد.."
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.birth_place}
                            value={new_user.birth_place}
                            onChange={handleChange}
                          />
                        </div>
                        {new_user.birth_place === "88" && (
                          <Fragment>
                            <div className="col-lg-4 col-sm-6">
                              <InputElement
                                mb4="mb-4"
                                name="other_birth_place"
                                labelHtmlFor="other_birth_place"
                                labelClassName={` required ${styleRegister["form-label"]} form-label`}
                                labelText="محل ميلاد أخر"
                                inputType="text"
                                inputClassName={`${styleRegister["form-control"]} form-control`}
                                inputID="other_birth_place"
                                pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                                pText={error_new_user.other_birth_place}
                                value={new_user.other_birth_place}
                                onChange={handleChange}
                                maxLength={100}
                                allowedPattern={
                                  /^(?!.*؟)(?:[A-Za-z\s]+|[\u0600-\u06FF\s]+)$/
                                }
                              />
                            </div>
                          </Fragment>
                        )}
                        <div className="col-lg-4 col-sm-6">
                          <SearchSelectElement
                            mb4="mb-4"
                            labelHtmlFor="gender"
                            labelClassName={` required form-label ${styleRegister["form-label"]}`}
                            labelText="النوع"
                            selectClassName={`${styleRegister["form-select"]} form-select`}
                            selectID="gender"
                            inputId="gender_input"
                            name="gender"
                            options={genders_options}
                            default="أختار النوع .."
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.gender}
                            value={new_user.gender}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-lg-4 col-sm-6">
                          <InputElement
                            mb4="mb-4"
                            name="email"
                            labelHtmlFor="email"
                            labelClassName={`${new_user?.country_code !== "eg" && "required"} ${styleRegister["form-label"]} form-label`}
                            labelText="البريد الإلكتروني"
                            inputType="text"
                            inputClassName={`${styleRegister["form-control"]} form-control`}
                            inputID="email"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.email}
                            value={new_user.email}
                            onChange={handleChange}
                            maxLength={100}
                            allowedPattern={/^[A-Za-z0-9._@\-]+$/}
                          />
                        </div>
                        <div className="col-lg-4 col-sm-6">
                          <InputElement
                            mb4="mb-4 parent-password"
                            name="password"
                            labelHtmlFor="password"
                            labelClassName={` required ${styleRegister["form-label"]} form-label`}
                            labelText="كلمة المرور"
                            inputType="password"
                            inputClassName={`${styleRegister["form-control"]} form-control`}
                            inputID="password"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.password}
                            value={new_user.password}
                            onChange={handleChange}
                            maxLength={255}
                            allowedPattern={/^[^\s]+$/}
                            tooltipText="كلمه السر يجب أن تحتوي ع حرف كبير وحرف صغير وحرف خاص مثل ( ! , @, #, $, %, &, *, +, =, {, }, ?, <, >, '' , '   ) ورقم ولا يقل عن 8 حروف و لا يزيد عن 10 حروف"
                          />
                        </div>
                        <div className="col-lg-4 col-sm-6">
                          <InputElement
                            mb4="mb-4 parent-password"
                            name="password_confirmation"
                            labelHtmlFor="password_confirmation"
                            labelClassName={` required ${styleRegister["form-label"]} form-label`}
                            labelText="تاكيد كلمة المرور"
                            inputType="password"
                            inputClassName={`${styleRegister["form-control"]} form-control`}
                            inputID="password_confirmation"
                            pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                            pText={error_new_user.password_confirmation}
                            value={new_user.password_confirmation}
                            onChange={handleChange}
                            allowedPattern={/^[^\s]+$/}
                            maxLength={255}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 mt-3" dir="rtl">
                      {/* Checkbox row */}
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          className="form-check-input mt-1 m-1 "
                          type="checkbox"
                          id="acceptTerms"
                          checked={acceptTerms}
                          onChange={(e) => {
                            setAcceptTerms(e.target.checked);
                            if (e.target.checked) setAcceptTermsError("");
                          }}
                        />

                        <label
                          className="form-check-label w-100"
                          htmlFor="acceptTerms"
                        >
                          <span className={styleRegister.requiredAsterisk}>
                            *
                          </span>
                          <strong>
                            أقر بصحة البيانات و الإطلاع على{" "}
                            <button
                              className="text-primary fw-bold text-decoration-underline border-0 bg-transparent p-0"
                              onClick={() =>
                                setCurrentView("termsAndCondition")
                              }
                            >
                              الشروط و الأحكام و أحكام الخصوصية{" "}
                            </button>{" "}
                            و الموافقة عليها
                          </strong>
                        </label>
                      </div>

                      {/* ✅ Error directly under checkbox */}
                      {acceptTermsError && (
                        <div className="text-danger fw-bolder mt-2 pe-4 me-3">
                          {acceptTermsError}
                        </div>
                      )}
                    </div>

                    <div
                      className={`${styleRegister["register-btn"]} d-flex justify-content-start  gap-3  align-items-center pb-5 mt-4`}
                    >
                      {/* <button
                    onClick={registerUser}
                    className={`${styleRegister["btn-register"]}`}
                  >
                    إنشاء حساب
                  </button> */}
                      <button
                        type="button"
                        onClick={handleValidateOpenModal}
                        disabled={isSubmitDisabled}
                        className={
                          isSubmitDisabled
                            ? `${styleRegister["btn-register"]} ${styleRegister["btn-register-disabled"]}`
                            : styleRegister["btn-register"]
                        }
                      >
                        إنشاء حساب
                      </button>
                      <Link
                        to="/login"
                        className={`${styleRegister["btn-login"]}`}
                      >
                        إلغاء
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          <Footer />
        </>
      ) : (
        <TermsAndCondition setCurrentView={setCurrentView} />
      )}
    </>
  );
}

export default Register;
